import React, { useState } from "react";
import AccountView from "../../components/views/account-view/AccountView";
import PlansView from "../../components/views/plans-view/PlansView";

export default function AccountPage() {
  const [activeTab, setActiveTab] = useState("billing");

  const tabClass = (tab) =>
    `w-1/2 px-3 py-2.5 rounded-md text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
      activeTab === tab
        ? "bg-gray-900 text-white shadow"
        : "text-slate-600 hover:bg-slate-50"
    }`;

  return (
    <div>
      <div className="pt-4">
        <div className="border border-slate-200 rounded-md p-1 w-full bg-white">
          <nav className="flex w-full gap-1" aria-label="Account tabs">
            <button
              type="button"
              className={tabClass("profile")}
              onClick={() => setActiveTab("profile")}
            >
              Profile
            </button>
            <button
              type="button"
              className={tabClass("billing")}
              onClick={() => setActiveTab("billing")}
            >
              Billing
            </button>
          </nav>
        </div>
      </div>

      {activeTab === "profile" ? <AccountView /> : <PlansView />}
    </div>
  );
} 